export default __webpack_public_path__ + "static/media/fatsals.file.c0ea9dae.jpg";